import React, { useCallback } from "react";
import { Button } from "@shopify/polaris";
import { useAppMutation } from "../../../../hooks/index.js";

const UndoButton = ({ historyItem, setActionHistory, handleClose }) => {
  const { isLoading: isLoadingUndo, mutate: mutateUndo } = useAppMutation({
    url: "/api/action-history/undo",
    reactMutationOptions: {
      onSuccess(data) {
        setActionHistory((prev) => prev.map(item => {
          if (item.id === data.history.id) {
            return data.history;
          }
          return item;
        }));
      }
    }
  });

  const handeUndo = useCallback(() => {
    mutateUndo({ historyId: historyItem.id });
  }, [mutateUndo, historyItem]);

  return (
    <Button
      loading={isLoadingUndo}
      disabled={historyItem.isUndo}
      onClick={handeUndo}
    >
      {historyItem.isUndo ? "Undone" : "Undo"}
    </Button>
  );
};

export default UndoButton;